import React, {useContext, useState} from 'react';
import {CategoryContext} from "./CategoryContext";

export const SearchInput: React.FunctionComponent = () => {
    const {query, setQuery} = useContext(CategoryContext);
    const [localQuery, setLocalQuery] = useState(query ?? "");

    const executeQuery = () => {
        setQuery && setQuery(localQuery);
    }

    const resetQuery = () => {
        setLocalQuery('');
        setQuery && setQuery('');
    }

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        switch (e.key) {
            case 'Enter':
                executeQuery();
                break;
            case 'Escape':
                resetQuery();
                break;
        }
    };

    return (
        <>
            <div className="col-xs-3">Zoeken naar:</div>
            <div className="col-xs-9">
                <input type="search" value={localQuery} style={{flex: 2}} onChange={e => { setLocalQuery(e.currentTarget.value); }} onKeyDown={onKeyDown} />
                { localQuery && <button className="tool-button search" type="button" onClick={resetQuery}>⌫</button>}
                <button className="tool-button search" type="button" onClick={executeQuery} style={{ flex: 1 }}>🔍</button>
            </div>
        </>
    );
};
